module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_2.be3db55.webp";